import React, { useState, useEffect, useCallback } from 'react';
import ModalVisita from './ModalVisita';
import CalendarioVisitas from './CalendarioVisitas';

const VisitasObra = ({ id_tabla_obras, obraLabel, area_responsable = '', token }) => {
    const [visitas, setVisitas] = useState([]);
    const [loading, setLoading] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [visitaEditable, setVisitaEditable] = useState(null);
    const [fechaInicialModal, setFechaModalLocal] = useState(null);

    const fetchVisitas = useCallback(async () => {
        if (!id_tabla_obras) return;
        setLoading(true);
        try {
            // Muestra las visitas de TODAS las obras del área responsable de la obra actual
            const qs = area_responsable
                ? `?area_responsable=${encodeURIComponent(area_responsable)}`
                : `?id_tabla_obras=${id_tabla_obras}`;
            const res = await fetch(`/api/visitas${qs}`, {
                headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
            });
            if (!res.ok) throw new Error('Error al cargar visitas');
            const data = await res.json();
            setVisitas(data);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }, [id_tabla_obras, area_responsable, token]);

    useEffect(() => {
        fetchVisitas();
    }, [fetchVisitas]);

    const abrirAlta = (fecha = null) => {
        setVisitaEditable(null);
        setFechaModalLocal(fecha);
        setModalOpen(true);
    };

    const abrirEdicion = (visita) => {
        setVisitaEditable(visita);
        setFechaModalLocal(null);
        setModalOpen(true);
    };

    return (
        <div className="p-4">
            <div className="flex flex-wrap items-center justify-between gap-2 mb-2">
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white">
                    Calendario de visitas{obraLabel ? ` — ${obraLabel}` : ''}
                </h3>
                <button
                    onClick={() => abrirAlta()}
                    className="px-4 py-2 text-sm bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors"
                >
                    + Agendar visita
                </button>
            </div>

            {loading && <p className="text-gray-500">Cargando visitas...</p>}

            {!loading && (
                <CalendarioVisitas
                    visitas={visitas}
                    obras={[]}
                    filtroObraFijo={''}
                    filtroAreaResponsable={area_responsable}
                    onDobleClickFecha={(fecha) => abrirAlta(fecha)}
                    onDobleClickVisita={(visita) => abrirEdicion(visita)}
                />
            )}

            <ModalVisita
                isOpen={modalOpen}
                onClose={() => setModalOpen(false)}
                token={token}
                id_tabla_obras={id_tabla_obras}
                obraLabel={obraLabel}
                fechaInicial={fechaInicialModal}
                visitaEditable={visitaEditable}
                onGuardada={fetchVisitas}
            />
        </div>
    );
};

export default VisitasObra;